import(/* webpackMode: "eager" */ "/usr/src/app/config/image-loader.ts");
;
import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/@ant-design/icons/es/components/AntdIcon.js");
;
import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/app/join/page.module.scss");
